<template>
  <div></div>
</template>

<script>
import { interact } from "fire-wind-water";

export default {
  name: "Home",
  created() {
    window.console.log(interact.browseInfo);
    if (interact.isMobile == 1) {
      window.location.hash = "#/wap";
    } else {
      window.location.hash = "#/pc";
    }
  }
};
</script>
